
    <p-tree #tree 
        selectionMode="single"
        [value]="nodes" 
        [(selection)]="selectedNode"
        (onNodeSelect)="onNodeSelect($event)"
        (onNodeUnselect)="onNodeUnselect($event)"
        (onNodeExpand)="onNodeSelect($event)"
        class="no-border">
        
        <ng-template let-node pTemplate="default">
            <span [attr.title]="showToolTip(node)" *ngIf="((selectedNode !== node) || isResultNode(node))" [ngStyle]="{'color': isValid(node) ? 'black' : 'red', 'font-weight':  isBold(node) ? 'bold' : 'normal'}">{{ node.label }}</span>
            <span [attr.title]="showToolTip(node)" *ngIf="(selectedNode === node && !isResultNode(node))" [ngStyle]="{'color': isValid(node) ? 'black' : 'red', 'font-weight':  isBold(node) ? 'bold' : 'normal'}"><i class="pi pi-pencil"></i> {{ node.label }}</span>
        </ng-template>   
        
    </p-tree>



